export default __webpack_public_path__ + "static/media/assemblySim2.15ad3fc2.jpg";